import { Component, Input, OnInit } from '@angular/core';
import { timer } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { DestroyDirective } from '../destroy-abstract/destroy.abstract';

@Component({
  selector: 'app-use-progress-bar',
  templateUrl: './use-progress-bar.component.html',
  styleUrls: ['./use-progress-bar.component.scss']
})
export class UseProgressBarComponent
  extends DestroyDirective
  implements OnInit
{
  /**
   * importo totale
   */
  @Input() totalAmount = 0;

  /**
   * importo utilizzato
   */
  @Input() usedAmount = 0;

  /**
   * durata totale dell'animazione
   */
  @Input() duration = 1000;

  /**
   * percentuale progressiva
   */
  progress = 0;

  /**
   * percentuale di utilizzo (calcolata da importo totale e importo utilizzato)
   */
  private usedPercentage: number;

  /**
   * tempo di refresh
   */
  private refreshTime: number;

  constructor() {
    super();
  }

  ngOnInit() {
    this.setProgress();
  }

  /**
   * imposta il progress
   */
  private setProgress(): void {
    this.calcUsedPercentage();
    this.calcRefreshTime();
    this.cleanProgress();

    if (this.usedPercentage <= 0 || this.refreshTime <= 0) {
      return;
    }

    this.updateProgressUntilComplete();
  }

  /**
   * azzera la percentuale di progresso
   */
  private cleanProgress(): void {
    this.progress = 0;
  }

  /**
   * incomincia l'animazione
   */
  private updateProgressUntilComplete(): void {
    timer(0, this.refreshTime)
      .pipe(
        takeWhile(() => this.progress < this.usedPercentage),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.progress++;
      });
  }

  /**
   * calcola la percentuale di utilizzo
   */
  private calcUsedPercentage(): void {
    this.usedPercentage =
      Number((this.usedAmount / this.totalAmount).toFixed(2)) * 100;
  }

  /**
   * calcola l'intervallo di incremento
   */
  private calcRefreshTime(): void {
    this.refreshTime = Math.round(this.duration / this.usedPercentage);
  }
}
